// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XiOv","index":"styles_index__G7hv9"};